import React from 'react';
import './DeleteAccount.css';

function DeleteAccount() {
  return (
    <div className="policy-container">
      <div className="policy-content">
        <h1>TeleReels Delete Account</h1>
        
        <section>
          <h2>Delete Account</h2>
          <p>
            To delete your TeleReels account, please send an email to{' '}
            <a href="mailto:contact@telereels.com">contact@telereels.com</a>. In the email, 
            please provide your username and the email address associated with your account. 
            Once your account is deleted, all of your personal data, including your watch history 
            and settings, will be permanently removed from our servers. However, please note that 
            your watch history and other data may be retained in certain circumstances, such as 
            for legal or regulatory purposes. If you have any other questions or concerns, please 
            do not hesitate to contact us at{' '}
            <a href="mailto:contact@telereels.com">contact@telereels.com</a>.
          </p>
        </section>
      </div>
    </div>
  );
}

export default DeleteAccount;
